import type * as React from 'react';

import type { TraceProps, WithTrace } from '../../utils';
import type { useStyles } from './Notification.styles';

export interface IconBaseProps {
    type: NotificationType;
    description?: string | React.ReactNode;
}

type StyleClasses = { classes: ReturnType<typeof useStyles>['classes'] };

export type IconProps = IconBaseProps & TraceProps & StyleClasses & WithTrace;

export interface OwnProps {
    message: string | React.ReactNode;
    messageComponent?: React.ElementType; // Changes the parent component used by Typography, e.g. 'span'
    description?: string | React.ReactNode;
    closeCallback?: () => void;
    children?: React.ReactNode;
}

export type NotificationProps = IconBaseProps & OwnProps & TraceProps & WithTrace & StyleClasses;

export enum NotificationType {
    ERROR = 'error',
    WARNING = 'warning',
    SUCCESS = 'success',
    INFO = 'info',
    ERROR_LIGHT = 'errorLight',
    WARNING_LIGHT = 'warningLight',
    INFO_LIGHT = 'infoLight',
    SUCCESS_LIGHT = 'successLight',
}
